import React, { Component } from "react";
import Img from "react-image";
import _ from "lodash";
import srcIconPhoto from "../../../../../styles/img/icon-photo.svg";

import { connect } from "react-redux";
import {
  recupererEnfant,
  updateIdentiteSimpleInfoEnfant,
  updateIdentiteSimpleInfoParent,
  updateIdentiteSimpleInfoTierce,
  archiveEnfant,
  deleteEnfant,
  deleteIdentiteSimpleInfoParent,
  updateCouplage,
  updatePhotoEnfant
} from "../les-tabs-ducks/Identite.ducks";
import srcIconCheck from "../../../../../styles/img/icon-check-white.svg";
import moment from "moment";
import { getAccount } from "../../../../auth/Auth.ducks";
import Classnames from "classnames";
import Close from "../../../../../Icons/Close";
import { toUpperCaseFirst, toLowerCaseFirst } from "../../../../../ReactConst";
import imgUrlAvatar from "../../../../../styles/img/enfant-avatar.jpg";
import ModalHoraires from "./ModalHoraires";
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import DateFnsUtils from "@date-io/moment";
import "moment-timezone";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import ModaleArchivage from "./ModaleArchivage";
import ModaleSuppresion from "./ModaleSuppression";
import ModaleSuppressionInfoParent from "./ModaleSuppressionInfoParent";
import ModalePhoto from "./ModalePhoto";
import iconValider from "../../../../../styles/img/icon-check-white.svg";
import { API } from "../../../../../const";
import { Service } from "../../../../service/service";
import { isMobile } from "react-device-detect";
import { makeStyles } from "@material-ui/core/styles";
import "./style.css";
import UploadMobile from "./UploadMobile";
import { openSnackBar } from "../../../../../reducers";
import {
  getSections,
  assignEnfantSection,
  removeEnfantSection,
} from "../../creche/sections.ducks";
import { withTranslation } from 'react-i18next';

const materialTheme = createMuiTheme({
  palette: {
    primary: { main: "#1d4cc5" },
  },
  overrides: {
    MuiInputBase: {
      root: {
        position: "relative",
        boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none",
        padding: "0 15px",
        fontWeight: "600",
        fontSize: "18px",
        color: "#000",
      },
      input: {
        textAlign: "center",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none !important",
        fontWeight: "normal",
        fontSize: "18px",
        color: "#000",
      },
    },
    MuiInput: {
      underline: {
        "&::before": {
          content: "none",
        },
        "&::after": {
          content: "none",
        },
      },
    },
  },
});
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const IconPhoto = () => (
  <object data={srcIconPhoto} type="image/svg+xml" className="img-fluid" />
);
const IconCheckWhite = () => <Img src={srcIconCheck} className="img-fluid" />;
const IconValider = () => (
  <Img src={iconValider} className="btn-valid img-fluid" alt="iconPhoto" />
);

class Identite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numJour: 0,
      horaire: "",
      nomPrenom: "",
      dateNaissance: "",
      dateAcceptation: "",
      nomPrenomparent: "",
      telephone: "",
      parents: [],
      tierces: [],
      showTierce: false,
      email: "",
      numeroTel: "",
      formErrors: { sexe: "", email: "", numeroTel: "", nomPrenom: "" },
      emailValid: true,
      numeroTelValid: true,
      formValid: true,
      photoChanged: false,
      newHoraires: {},
      newTierce: {
        PrenomNomTierce: "",
        numeroTel: "",
        nom: "",
        prenom: "",
        lienDeParente: "Ami",
      },
      couplageActif: false,
      ModalHoraires: false,
      horaireDebut: moment(),
      horaireFin: moment(),
      marcheActif: false,
      biberonActif: false,
      biberonFrequence: null,
      sexeEnfant: "",
      poidsEnfant: "",
      tailleEnfant: "",
      ModaleArchivage: false,
      ModaleSuppresion: false,
      ModaleSuppresionInfoParent: false,
      ModalePhoto: false,
      etatCompte: "",
      lienPhoto: "",
      file: null,
      poidsEnfantShow: "",
      kilo: true,
      frequence: true,
      taille: true,
      modalUploadMobile: false,
      croppedFile: "",
      styleFadeIn: false,
      fromArchive: window.location.pathname.includes("archives"),
      showPhoto: null,
      selectedParentToDelete: null
    };
    this.onChangeNomParent = this.onChangeNomParent.bind(this);
    this.onChangeNomTierce = this.onChangeNomTierce.bind(this);
    this.showAddTierce = this.showAddTierce.bind(this);
    this.handleChangeMulitple = this.handleChangeMulitple.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleChangeCouplage = this.handleChangeCouplage.bind(this);
    this.deleteTierce = this.deleteTierce.bind(this);
    this.showModalHoraires = this.showModalHoraires.bind(this);
    this.onClose = this.onClose.bind(this);
    this.haveTwoParents = this.haveTwoParents.bind(this);
    this.onSubmitModal = this.onSubmitModal.bind(this);
    this.handleChangeHoraire = this.handleChangeHoraire.bind(this);
    this.handleChangeTimeStart = this.handleChangeTimeStart.bind(this);
    this.handleChangeTimeEnd = this.handleChangeTimeEnd.bind(this);
    this.onChangeEnfant = this.onChangeEnfant.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmitInfoEnfant = this.handleSubmitInfoEnfant.bind(this);
    this.showModalArchivage = this.showModalArchivage.bind(this);
    this.showModalSuppressionInfoParent = this.showModalSuppressionInfoParent.bind(this);
    this.showModalSuppression = this.showModalSuppression.bind(this);
    this.onCloseModaleArchive = this.onCloseModaleArchive.bind(this);
    this.onCloseModaleSuppression = this.onCloseModaleSuppression.bind(this);
    this.onCloseModaleSuppressionInfoParent = this.onCloseModaleSuppressionInfoParent.bind(this);
    this.onSubmitSuppression = this.onSubmitSuppression.bind(this);
    this.onSubmitSuppressionInfoParent = this.onSubmitSuppressionInfoParent.bind(this);
    this.onSubmitArchive = this.onSubmitArchive.bind(this);
    this.handleSubmitInfoTierce = this.handleSubmitInfoTierce.bind(this);
    this.showModalPhoto = this.showModalPhoto.bind(this);
    this.onCloseModalePhoto = this.onCloseModalePhoto.bind(this);
    this.errorClass = this.errorClass.bind(this);
    this.uploadPhoto = this.uploadPhoto.bind(this);
    this.handleChangePoids = this.handleChangePoids.bind(this);
    this.onCloseUploadMobile = this.onCloseUploadMobile.bind(this);
    this.getCroppedImage = this.getCroppedImage.bind(this);
    this.uploadPhotoMobile = this.uploadPhotoMobile.bind(this);
    this.renderContent = this.renderContent.bind(this);
  }
  getCroppedImage(file) {
    this.setState({ croppedFile: file });
  }
  handleChangeBiberon = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    this.setState({ biberonActif: !this.state.biberonActif });
  };
  handleChangeMarche = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    this.setState({ marcheActif: !this.state.marcheActif });
  };
  renderInput = (props) => (
    <div className="form-group">
      <input
        readOnly
        className="form-control ipt-id-naissance"
        type="text"
        onClick={props.onClick}
        id={props.id}
        value={props.textLabel + props.value}
        {...props.inputProps}
      />
    </div>
  );
  componentDidMount() {
    this.props.getSections(localStorage.getItem("token"));
    if (!_.isEmpty(this.props.kidItem)) {
      this.props.getAccount(localStorage.getItem("token"));
      let horaire = "";
      let horaireDebut;
      let horaireFin;
      let numJour = Array.from(
        _.values(this.props.kidItem.horairesDetails.horaires)
      ).reduce((accu, element) => {
        if (element.ouvert) {
          horaireDebut = moment(element.horaireDebut, "HH:mm:ss").format(
            "HH[h]mm"
          );
          horaireFin = moment(element.horaireFin, "HH:mm:ss").format("HH[h]mm");
          horaire =
            (horaireDebut.charAt(0) === "0"
              ? horaireDebut.slice(1)
              : horaireDebut) +
            "-" +
            horaireFin;
        }
        return element.ouvert ? accu + 1 : accu;
      }, 0);
      let newLiensParente = Array.from(
        this.props.kidItem.liensParente,
        (element) =>
          Object.assign({}, element.parent, {
            noTouch: true,
            couplageActif: element.couplageActif,
            PrenomNom:
              toUpperCaseFirst(element.parent.prenom) +
              " " +
              toUpperCaseFirst(element.parent.nom),
            fullAdress:
              element.parent.adresse.rue +
              "\n" +
              element.parent.adresse.codePostal +
              "\n" +
              element.parent.adresse.ville +
              "\n" +
              element.parent.adresse.pays,
          })
      );
      let newTierces = [];
      if (this.props.kidItem.tierceAutorises) {
        newTierces = Array.from(this.props.kidItem.tierceAutorises, (tierce) =>
          Object.assign({}, tierce, {
            PrenomNomTierce:
              toUpperCaseFirst(tierce.prenom) +
              " " +
              toUpperCaseFirst(tierce.nom),
          })
        );
      }
      let frequenceBiberon =
        !this.state.fromArchive && this.props.kidItem.biberon.actif
          ? this.props.kidItem.biberon.frequence
          : null;
      let poid = this.props.kidItem.poid ? this.props.kidItem.poid : null;
      let taille = this.props.kidItem.taille ? this.props.kidItem.taille : null;
      let twoOneParents =
        newLiensParente.length < 2
          ? [
            ...newLiensParente,
            {
              noTouch: true,
              nom: "",
              prenom: "",
              email: "",
              adresse: { rue: "", ville: "", codePostal: "", pays: "" },
              situation: "MARIE",
              numeroTel: "",
              etatCompte: "A_CONFIRMER",
              couplageActif: false,
              PrenomNom: "",
              fullAdress: "",
              id: null,
            },
          ]
          : newLiensParente;
      let rampeur = !this.state.fromArchive
        ? !this.props.kidItem.rampeur
        : false;
      let biberon =
        !this.state.fromArchive && this.props.kidItem.biberon.actif
          ? this.props.kidItem.biberon.actif
          : false;
      let lienPhoto = this.props.kidItem.lienPhoto
        ? this.props.kidItem.lienPhoto
        : null;
      this.setState({
        horaire: horaire,
        numJour: numJour,
        nomPrenom:
          toUpperCaseFirst(this.props.kidItem.prenom) +
          " " +
          toUpperCaseFirst(this.props.kidItem.nom),
        marcheActif: rampeur,
        biberonActif: biberon,
        biberonFrequence: frequenceBiberon,
        sexeEnfant: toUpperCaseFirst(this.props.kidItem.sexe),
        poidsEnfant: poid,
        tailleEnfant: taille,
        dateNaissance: this.props.kidItem.dateNaissance,
        dateAcceptation: this.props.kidItem.dateAcceptation,
        nomPrenomparent: "",
        parents: twoOneParents,
        tierces: newTierces,
        nomPrenomTierce: "",
        newHoraires: this.props.kidItem.horairesDetails.horaires,
        horaireDebut: moment(horaireDebut, "HH[h]mm"),
        horaireFin: moment(horaireFin, "HH[h]mm"),
        lienPhoto: this.props.kidItem.lienPhoto,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.kidItem !== this.props.kidItem) {
      let horaire = "";
      let horaireDebut;
      let horaireFin;
      let numJour = Array.from(
        _.values(this.props.kidItem.horairesDetails.horaires)
      ).reduce((accu, element) => {
        if (element.ouvert) {
          horaireDebut = moment(element.horaireDebut, "HH:mm:ss").format(
            "HH[h]mm"
          );
          horaireFin = moment(element.horaireFin, "HH:mm:ss").format("HH[h]mm");
          horaire =
            (horaireDebut.charAt(0) === "0"
              ? horaireDebut.slice(1)
              : horaireDebut) +
            "-" +
            horaireFin;
        }
        return element.ouvert ? accu + 1 : accu;
      }, 0);
      let newLiensParente = Array.from(
        this.props.kidItem.liensParente,
        (element) =>
          Object.assign({}, element.parent, {
            noTouch: true,
            couplageActif: element.couplageActif,
            PrenomNom:
              toUpperCaseFirst(element.parent.prenom) +
              " " +
              toUpperCaseFirst(element.parent.nom),
            fullAdress:
              element.parent.adresse.rue +
              "\n" +
              element.parent.adresse.codePostal +
              "\n" +
              element.parent.adresse.ville +
              "\n" +
              element.parent.adresse.pays,
          })
      );
      let newTierces = [];
      if (this.props.kidItem.tierceAutorises) {
        newTierces = Array.from(this.props.kidItem.tierceAutorises, (tierce) =>
          Object.assign({}, tierce, {
            PrenomNomTierce:
              toUpperCaseFirst(tierce.prenom) +
              " " +
              toUpperCaseFirst(tierce.nom),
          })
        );
      }
      let frequenceBiberon =
        !this.state.fromArchive && this.props.kidItem.biberon.actif
          ? this.props.kidItem.biberon.frequence
          : null;
      let poid = this.props.kidItem.poid ? this.props.kidItem.poid : null;
      let taille = this.props.kidItem.taille ? this.props.kidItem.taille : null;
      let twoOneParents =
        newLiensParente.length < 2
          ? [
            ...newLiensParente,
            {
              noTouch: true,
              nom: "",
              prenom: "",
              email: "",
              adresse: { rue: "", ville: "", codePostal: "", pays: "" },
              situation: "CELIBATAIRE",
              numeroTel: "",
              etatCompte: "A_CONFIRMER",
              couplageActif: false,
              PrenomNom: "",
              fullAdress: "",
              id: null,
            },
          ]
          : newLiensParente;
      let rampeur = !this.state.fromArchive
        ? !this.props.kidItem.rampeur
        : false;

      let biberon =
        !this.state.fromArchive && this.props.kidItem.biberon.actif
          ? this.props.kidItem.biberon.actif
          : false;
      let lienPhoto = this.props.kidItem.lienPhoto
        ? this.props.kidItem.lienPhoto
        : null;
      let formErrors = { sexe: "", email: "", numeroTel: "", nomPrenom: "" };
      this.setState({
        formErrors: formErrors,
        horaire: horaire,
        numJour: numJour,
        nomPrenom:
          toUpperCaseFirst(this.props.kidItem.prenom) +
          " " +
          toUpperCaseFirst(this.props.kidItem.nom),
        marcheActif: rampeur,
        biberonActif: biberon,
        biberonFrequence: frequenceBiberon,
        sexeEnfant: toUpperCaseFirst(this.props.kidItem.sexe),
        poidsEnfant: poid,
        tailleEnfant: taille,
        dateNaissance: this.props.kidItem.dateNaissance,
        dateAcceptation: this.props.kidItem.dateAcceptation,
        nomPrenomparent: "",
        parents: twoOneParents,
        tierces: newTierces,
        nomPrenomTierce: "",
        newHoraires: this.props.kidItem.horairesDetails.horaires,
        horaireDebut: moment(horaireDebut, "HH[h]mm"),
        horaireFin: moment(horaireFin, "HH[h]mm"),
        lienPhoto: this.props.kidItem.lienPhoto,
      });
    }
  }

  //  Funcion validation email
  validateField(name, value, index) {
    let fieldValidationErrors = this.state.formErrors;
    let emailValid = this.state.emailValid;
    let numeroTelValid = this.state.numeroTelValid;
    switch (name) {
      case "email":
        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.email = emailValid ? "" : " est invalide";
        break;
      case "numeroTel":
        numeroTelValid = value.match(/^((\+)33|033|0)[1-9](\d{2}){4}$/g);
        fieldValidationErrors.numeroTel = numeroTelValid ? "" : " est invalide";
        break;
    }
    let newObj = {
      ...this.state.formErrors,
      [`${name}${index}`]: fieldValidationErrors[name],
    };
    this.setState(
      {
        formErrors: newObj,
        emailValid: emailValid,
        numeroTelValid: numeroTelValid,
      },
      this.validateForm
    );
  }
  //  Validation fomr for email
  validateForm() {
    this.setState({
      formValid: this.state.emailValid && this.state.numeroTelValid,
    });
  }
  //Error class validation
  errorClass(error) {
    return _.isEmpty(error) ? "" : "error-mess";
  }
  // Function Nom parent
  onChangeNomParent = (event, index) => {
    let value = event.target.value.split(" ");
    let parentNom =
      value.slice(1).join(" ") && value.slice(1).join(" ") !== " "
        ? value.slice(1).join(" ")
        : "";
    let parentPrenom = value[0] ? value[0] : "";

    let newChangedList = this.state.parents.map((p, i) =>
      index === i
        ? {
          ...p,
          noTouch: false,
          PrenomNom: event.target.value,
          nom: toUpperCaseFirst(parentNom),
          prenom: toUpperCaseFirst(parentPrenom),
        }
        : p
    );
    let name = event.target.name + index;
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      [name]: "",
    });
    this.setState({
      parents: newChangedList,
      formErrors: fieldValidationErrors,
    });
  };
  // Function Change Adresse
  onChangeAdresse = (event, index) => {
    let value = event.target.value;
    let name = event.target.name;
    let newChangedList = this.state.parents.map((p, i) =>
      index === i
        ? { ...p, adresse: Object.assign({}, p.adresse, { [name]: value }) }
        : p
    );
    this.setState({ parents: newChangedList });
  };

  // HandleChange multiple
  handleChangeMulitple(event, id, index) {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    let newChangedList = this.state.parents.map((p, i) =>
      index === i ? { ...p, noTouch: false, [name]: event.target.value } : p
    );
    this.setState({ parents: newChangedList, [name]: value }, () => {
      this.validateField(name, value, index);
    });
  }
  // Function change Nom Tierce
  onChangeNomTierce = (event, id) => {
    let value = event.target.value.split(" ");
    let tierceNom =
      value.slice(1).join(" ") && value.slice(1).join(" ") !== " "
        ? value.slice(1).join(" ")
        : "";
    let tiercePrenom = value[0];

    let name = event.target.name;
    let nameP = "PrenomNomTierce" + id;
    let formErrors = Object.assign({}, this.state.formErrors, { [nameP]: "" });
    let newChangedList = this.state.tierces.map((p, index) =>
      index === id
        ? {
          ...p,
          PrenomNomTierce: event.target.value,
          nom: toUpperCaseFirst(tierceNom),
          prenom: toUpperCaseFirst(tiercePrenom),
        }
        : p
    );
    this.setState({ tierces: newChangedList, formErrors: formErrors });
  };
  // Function change Nom Enfant
  onChangeEnfant = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      [name]: "",
    });
    this.setState({ nomPrenom: value, formErrors: fieldValidationErrors });
  };
  // Function change dateNaissance et dateInscription
  handleChangeNaissance = (date) => {
    this.setState({
      dateNaissance: date,
    });
  };
  handleChangeAdmission = (date) => {
    this.setState({
      dateAcceptation: date,
    });
  };
  handleChange = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    switch (name) {
      case "poids":
        if (value === "") {
          this.setState({
            kilo: false,
          });
        } else {
          this.setState({
            kilo: true,
          });
        }
      case "tailleEnfant":
        if (value === "") {
          this.setState({
            taille: false,
          });
        } else {
          this.setState({
            taille: true,
          });
        }
      case "biberonFrequence":
        if (value === "") {
          this.setState({
            frequence: false,
          });
        } else {
          this.setState({
            frequence: true,
          });
        }
      default:
    }
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      [name]: "",
    });
    this.setState({ [name]: value, formErrors: fieldValidationErrors });
  };
  handleChangePoids = (event) => {
    if (event.target.value === "") {
      this.setState({
        kilo: false,
      });
    } else {
      this.setState({
        kilo: true,
      });
    }
    let value = event.target.value;
    let name = event.target.name;
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      [name]: "",
    });
    this.setState({ [name]: value, formErrors: fieldValidationErrors });
  };
  // Function handlechange Tierce

  handleChangeMulitpleTierces(event, id) {
    let name = event.target.name;
    let nameP = "PrenomNomTierce" + id;
    let nameTel = "numeroTelT" + id;
    let formErrors = Object.assign({}, this.state.formErrors, {
      [nameTel]: "",
    });
    let newChangedListTierces = this.state.tierces.map((p, index) =>
      index === id ? { ...p, [name]: event.target.value } : p
    );
    this.setState({ tierces: newChangedListTierces, formErrors: formErrors });
  }
  handleChangeCouplage(event, id, couplageActif) {
    let name = event.target.name;
    let newChangedListParents = this.state.parents.map((p) =>
      p.id === id ? { ...p, [name]: !couplageActif } : p
    );
    this.setState({ parents: newChangedListParents });
    let data = {
      couplageActif: !couplageActif,
      idParent: id,
    };
    this.props.updateCouplage(
      localStorage.getItem("token"),
      this.props.kidItem.id,
      data
    );
  }
  // Function show plus de Tierce
  showAddTierce() {
    if (
      !_.isEmpty(this.props.account) &&
      this.props.account.compteType === "ADMIN_CRECHE"
    ) {
      let nomParent = this.state.newTierce.PrenomNomTierce.split(" ");
      let newTierce = this.state.newTierce;
      newTierce.nom =
        nomParent.slice(1).join(" ") && nomParent.slice(1).join(" ") !== " "
          ? nomParent.slice(1).join(" ")
          : "";
      newTierce.prenom = nomParent[0] ? nomParent[0] : "";
      let name = "PrenomNomTierceN";
      let nameTel = "numeroTelN";
      let validNom = newTierce.nom ? "" : "sont obligatoires";
      let validPrenom = newTierce.prenom ? "" : "sont obligatoires";
      let numeroTelValid = newTierce.numeroTel.match(
        /^((\+)33|033|0)[1-9](\d{2}){4}$/g
      );
      let numeroTel =
        newTierce.numeroTel && numeroTelValid
          ? ""
          : newTierce.numeroTel && !numeroTelValid
            ? "Telephone est invalide"
            : "Ce champs est obligatoire";
      let formValid =
        _.isEmpty(validNom) && _.isEmpty(validPrenom) && _.isEmpty(numeroTel);
      let nomPrenom = validNom || validPrenom;
      if (formValid) {
        let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
          [name]: "",
          [nameTel]: "",
        });
        this.setState((prevState) => ({
          formErrors: fieldValidationErrors,
          tierces: [...prevState.tierces, newTierce],
          showTierce: true,
          newTierce: {
            PrenomNomTierce: "",
            numeroTel: "",
            nom: "",
            prenom: "",
            lienDeParente: "Ami",
          },
        }));
      } else {
        let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
          [name]: nomPrenom,
          [nameTel]: numeroTel,
        });
        this.setState({ formErrors: fieldValidationErrors });
      }
    }
  }
  // Function add Tierce
  onChangeAddTierce = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    let nameP = "PrenomNomTierceN";
    let nameTel = "numeroTelN";
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      [nameP]: "",
      [nameTel]: "",
    });
    this.setState((prevState) => ({
      formErrors: fieldValidationErrors,
      newTierce: { ...prevState.newTierce, [name]: value },
    }));
  };
  // delete Tierce
  deleteTierce = (event, id) => {
    let newArray = [];
    newArray = this.state.tierces.filter((element, index) => id !== index);
    this.setState((prevState) => ({
      tierces: [...newArray],
    }));
  };
  toggle() {
    this.props.toggle();
  }
  //Function to handle the informations in the horaire Modal Dialog
  handleChangeHoraire(name, day) {
    let arrayOfDays = [];
    if (!_.isEmpty(this.props.kidItem.horairesDetails.horaires)) {
      let horaires = this.state.newHoraires;
      let newDay = day.ouvert
        ? Object.assign(day, { ouvert: false })
        : Object.assign(day, { ouvert: true });
      horaires[name] = Object.assign({}, newDay);
      this.setState({ newHoraires: Object.assign({}, horaires) });
    }
  }
  // Function show plus de Tierce
  showModalHoraires() {
    this.setState({ ModalHoraires: true });
  }
  onSubmitModal() {
    let numJour = Array.from(_.values(this.state.newHoraires)).reduce(
      (accu, element) => {
        return element.ouvert ? accu + 1 : accu;
      },
      0
    );
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      ["numJour"]: "",
    });
    this.setState({
      ModalHoraires: false,
      numJour: numJour,
      formErrors: fieldValidationErrors,
    });
  }
  onClose() {
    this.setState({ ModalHoraires: false });
  }
  handleChangeTimeEnd(date) {
    this.setState(
      {
        horaireFin: moment(date),
      },
      () => {
        let horaireDebut = moment(this.state.horaireDebut).format("HH[h]mm");
        let horaireFin = moment(this.state.horaireFin).format("HH[h]mm");
        let horaire =
          horaireDebut.charAt(0) === "0"
            ? horaireDebut.slice(1) + "-" + horaireFin
            : horaireDebut + "-" + horaireFin;
        let newHoraires = this.state.newHoraires;
        Object.keys(newHoraires).forEach((nameOfDay) => {
          newHoraires[nameOfDay] = Object.assign({}, newHoraires[nameOfDay], {
            horaireFin: moment(this.state.horaireFin).format("HH:mm:ss"),
          });
        });
        this.setState({ horaire: horaire, newHoraires: newHoraires });
      }
    );
  }
  handleChangeTimeStart(date) {
    this.setState(
      {
        horaireDebut: moment(date),
      },
      () => {
        let horaireDebut = moment(this.state.horaireDebut).format("HH[h]mm");
        let horaireFin = moment(this.state.horaireFin).format("HH[h]mm");
        let horaire =
          horaireDebut.charAt(0) === "0"
            ? horaireDebut.slice(1) + "-" + horaireFin
            : horaireDebut + "-" + horaireFin;
        let newHoraires = this.state.newHoraires;
        Object.keys(newHoraires).forEach((nameOfDay) => {
          newHoraires[nameOfDay] = Object.assign({}, newHoraires[nameOfDay], {
            horaireDebut: moment(this.state.horaireDebut).format("HH:mm:ss"),
          });
        });

        this.setState({ horaire: horaire, newHoraires: newHoraires });
      }
    );
  }
  uploadPhotoMobile = (e) => {
    e.preventDefault();
    let tok = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("file", this.state.croppedFile);
    const response = Service.post(
      `${API}api/creche/files?category=PHOTO`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${tok}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    response.then((res) => {
      setTimeout(() => { }, 400);
      this.setState({
        fileId: res.data.files[0].fileId,
        lienPhoto: this.state.croppedFile,
        modalUploadMobile: false,
        photoChanged: true
      });
      this.props.updatePhotoEnfant(
        localStorage.getItem("token"),
        this.props.kidItem.id,
        this.state.fileId
      )
    });
    response.catch((err) => {
      console.log(err);
    });
  };
  uploadPhoto = (file) => {
    let tok = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("file", file);
    const response = Service.post(
      `${API}api/creche/files?category=PHOTO`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${tok}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    response.then((res) => {
      this.setState({
        fileId: res.data.files[0].fileId,
        showPhoto: file,
        photoChanged: true,
      });
      this.props.updatePhotoEnfant(
        localStorage.getItem("token"),
        this.props.kidItem.id,
        this.state.fileId
      )
      this.props.showPhoto(file);
    });
    response.catch((err) => {
      console.log("err", err);
    });
  };
  handleSubmitInfoParent(event) {
    event.preventDefault();
    let data = {};

    let validNom = this.state.parents[0].nom ? "" : "sont obligatoires";
    let validPrenom = this.state.parents[0].prenom ? "" : "sont obligatoires";
    let validEmail = !_.isEmpty(this.state.parents[0].email)
      ? this.state.formErrors.email0
      : "est obligatoire";
    let validTel = !_.isEmpty(this.state.parents[0].numeroTel)
      ? this.state.formErrors.numeroTel0
      : "est obligatoire";
    let validNom1 = this.state.parents[1].nom ? "" : "sont obligatoires";
    let validPrenom1 = this.state.parents[1].prenom ? "" : "sont obligatoires";
    let validEmail1 = !_.isEmpty(this.state.parents[1].email)
      ? this.state.formErrors.email1
      : "est obligatoire";
    let validTel1 = !_.isEmpty(this.state.parents[1].numeroTel)
      ? this.state.formErrors.numeroTel1
      : "est obligatoire";
    let formValid0 =
      _.isEmpty(validNom) &&
      _.isEmpty(validPrenom) &&
      _.isEmpty(validEmail) &&
      _.isEmpty(validTel);

    let emptyParent0 =
      _.isEmpty(this.state.parents[0].nom) &&
      _.isEmpty(this.state.parents[0].prenom) &&
      _.isEmpty(this.state.parents[0].email) &&
      _.isEmpty(this.state.parents[0].numeroTel);

    let formValid1 =
      _.isEmpty(validNom1) &&
      _.isEmpty(validPrenom1) &&
      _.isEmpty(validEmail1) &&
      _.isEmpty(validTel1);

    let emptyParent1 =
      _.isEmpty(this.state.parents[1].nom) &&
      _.isEmpty(this.state.parents[1].prenom) &&
      _.isEmpty(this.state.parents[1].email) &&
      _.isEmpty(this.state.parents[1].numeroTel);
    if (formValid0 && formValid1) {
      data = {
        parents: [
          {
            adresse: {
              codePostal: this.state.parents[0].adresse.codePostal,
              pays: this.state.parents[0].adresse.pays,
              rue: this.state.parents[0].adresse.rue,
              ville: this.state.parents[0].adresse.ville,
            },
            email: this.state.parents[0].email,
            etatCompte: this.state.parents[0].etatCompte,
            id: this.state.parents[0].id,
            nom: this.state.parents[0].nom,
            numeroTel: this.state.parents[0].numeroTel,
            prenom: this.state.parents[0].prenom,
            situation: this.state.parents[0].situation,
          },
          {
            adresse: {
              codePostal: this.state.parents[1].adresse.codePostal,
              pays: this.state.parents[1].adresse.pays,
              rue: this.state.parents[1].adresse.rue,
              ville: this.state.parents[1].adresse.ville,
            },
            email: this.state.parents[1].email,
            etatCompte: this.state.parents[1].etatCompte,
            id: this.state.parents[1].id,
            nom: this.state.parents[1].nom,
            numeroTel: this.state.parents[1].numeroTel,
            prenom: this.state.parents[1].prenom,
            situation: this.state.parents[1].situation,
          },
        ],
      };
      this.props.updateIdentiteSimpleInfoParent(
        localStorage.getItem("token"),
        this.props.kidItem.id,
        data
      );

      let formErrors = Object.assign({}, this.state.formErrors, {
        email0: "",
        numeroTel0: "",
        nom0: "",
        prenom0: "",
        nomPrenom0: "",
        nomPrenom1: "",
        email1: "",
        numeroTel1: "",
        nom1: "",
        prenom1: "",
      });
      this.setState({ formErrors: formErrors });
    } else {
      if (!emptyParent0 && formValid0 && emptyParent1) {
        data = {
          parents: [
            {
              adresse: {
                codePostal: this.state.parents[0].adresse.codePostal,
                pays: this.state.parents[0].adresse.pays,
                rue: this.state.parents[0].adresse.rue,
                ville: this.state.parents[0].adresse.ville,
              },
              email: this.state.parents[0].email,
              etatCompte: this.state.parents[0].etatCompte,
              id: this.state.parents[0].id,
              nom: this.state.parents[0].nom,
              numeroTel: this.state.parents[0].numeroTel,
              prenom: this.state.parents[0].prenom,
              situation: this.state.parents[0].situation,
            },
          ],
        };
        this.props.updateIdentiteSimpleInfoParent(
          localStorage.getItem("token"),
          this.props.kidItem.id,
          data
        );
        let formErrors = Object.assign({}, this.state.formErrors, {
          email0: "",
          numeroTel0: "",
          nom0: "",
          prenom0: "",
          nomPrenom0: "",
          nomPrenom1: "",
          email1: "",
          numeroTel1: "",
          nom1: "",
          prenom1: "",
        });
        this.setState({ formErrors: formErrors });
      } else if (emptyParent0 && formValid1 && !emptyParent1) {
        data = {
          parents: [
            {
              adresse: {
                codePostal: this.state.parents[1].adresse.codePostal,
                pays: this.state.parents[1].adresse.pays,
                rue: this.state.parents[1].adresse.rue,
                ville: this.state.parents[1].adresse.ville,
              },
              email: this.state.parents[1].email,
              etatCompte: this.state.parents[1].etatCompte,
              id: this.state.parents[1].id,
              nom: this.state.parents[1].nom,
              numeroTel: this.state.parents[1].numeroTel,
              prenom: this.state.parents[1].prenom,
              situation: this.state.parents[1].situation,
            },
          ],
        };
        this.props.updateIdentiteSimpleInfoParent(
          localStorage.getItem("token"),
          this.props.kidItem.id,
          data
        );
        let formErrors = Object.assign({}, this.state.formErrors, {
          email0: "",
          numeroTel0: "",
          nom0: "",
          prenom0: "",
          nomPrenom0: "",
          nomPrenom1: "",
          email1: "",
          numeroTel1: "",
          nom1: "",
          prenom1: "",
        });
        this.setState({ formErrors: formErrors });
      } else {
        if (!emptyParent0 && emptyParent1) {
          let nomPrenom0 = validNom || validPrenom;
          let formErrors = Object.assign({}, this.state.formErrors, {
            email0: validEmail,
            numeroTel0: validTel,
            nom0: validNom,
            prenom0: validPrenom,
            nomPrenom0: nomPrenom0,
          });
          this.setState({ formErrors: formErrors });
        } else if (emptyParent0 && !emptyParent1) {
          let nomPrenom1 = validNom1 || validPrenom1;
          let formErrors = Object.assign({}, this.state.formErrors, {
            nomPrenom1: nomPrenom1,
            email1: validEmail1,
            numeroTel1: validTel1,
            nom1: validNom1,
            prenom1: validPrenom1,
          });
          this.setState({ formErrors: formErrors });
        } else {
          let nomPrenom0 = validNom || validPrenom;
          let nomPrenom1 = validNom1 || validPrenom1;
          let formErrors = Object.assign({}, this.state.formErrors, {
            email0: validEmail,
            numeroTel0: validTel,
            nom0: validNom,
            prenom0: validPrenom,
            nomPrenom0: nomPrenom0,
            nomPrenom1: nomPrenom1,
            email1: validEmail1,
            numeroTel1: validTel1,
            nom1: validNom1,
            prenom1: validPrenom1,
          });
          this.setState({ formErrors: formErrors });
        }
      }
    }
  }

  handleSubmitInfoEnfant(event) {
    event.preventDefault();
    let nomprenomenfant = this.state.nomPrenom.split(" ");
    let validNom = !_.isEmpty(nomprenomenfant[1]) ? "" : "sont obligatoire";
    let validPrenom = !_.isEmpty(nomprenomenfant[0]) ? "" : "sont obligatoire";
    let validSexe = this.state.sexeEnfant ? "" : "Ce champ est obligatoire";
    let validPoids =
      this.state.poidsEnfant && this.state.poidsEnfant >= 0
        ? ""
        : this.state.poidsEnfant && this.state.poidsEnfant < 0
          ? "Ce champs ne peut être négatif"
          : "Ce champ est obligatoire";
    let validTaille =
      this.state.tailleEnfant && this.state.tailleEnfant >= 0
        ? ""
        : this.state.tailleEnfant && this.state.tailleEnfant < 0
          ? "Ce champs ne peut être négatif"
          : "Ce champ est obligatoire";
    let validDateNaissance = this.state.dateNaissance
      ? ""
      : "Ce champ est obligatoire";
    let validDateAccept = this.state.dateAcceptation
      ? ""
      : "Ce champ est obligatoire";
    let validNumJour = this.state.numJour > 0 ? "" : "Ce champ est obligatoire";
    let validBiberon =
      this.state.biberonActif === false
        ? ""
        : this.state.biberonFrequence && this.state.biberonFrequence >= 0
          ? ""
          : this.state.biberonFrequence && this.state.biberonFrequence < 0
            ? "Ce champs ne peut être négatif"
            : "Ce champ est obligatoire";
    let nomPrenom = validNom || validPrenom;
    let cleanHorraire = this.state.newHoraires;
    Object.keys(this.state.newHoraires).forEach((nameOfDay) => {
      delete cleanHorraire[nameOfDay].nameOfDay;
      delete cleanHorraire[nameOfDay].numDay;
    });
    let formValid =
      _.isEmpty(validNom) &&
      _.isEmpty(validPrenom) &&
      _.isEmpty(validTaille) &&
      _.isEmpty(validPoids) &&
      _.isEmpty(validSexe) &&
      _.isEmpty(validDateNaissance) &&
      _.isEmpty(validDateAccept) &&
      _.isEmpty(validBiberon) &&
      _.isEmpty(validNumJour);

    if (formValid) {
      console.log(this.state.fileId, this.props.kidItem)
      if (this.state.biberonActif && this.state.biberonFrequence) {
        let data = {
          biberonActif: this.state.biberonActif,
          biberonFrequence: this.state.biberonFrequence,
          dateAcceptation: moment(this.state.dateAcceptation).format(
            "YYYY-MM-DD"
          ),
          dateNaissance: moment(this.state.dateNaissance).format("YYYY-MM-DD"),
          horairesDetails: { horaires: cleanHorraire },
          nom: nomprenomenfant[1],
          poid: this.state.poidsEnfant,
          prenom: nomprenomenfant[0],
          rampeur: !this.state.marcheActif,
          sexe: this.state.sexeEnfant,
          taille: this.state.tailleEnfant,
        };

        this.props.updateIdentiteSimpleInfoEnfant(
          localStorage.getItem("token"),
          this.props.kidItem.id,
          data
        );
        let formErrors = Object.assign({}, this.state.formErrors, {
          nomPrenom: "",
          sexeEnfant: "",
          poidsEnfant: "",
          tailleEnfant: "",
          dateNaissance: "",
          dateAcceptation: "",
          biberonActif: "",
          numJour: "",
        });
        this.setState({ formErrors: formErrors });
      } else {
        let data = {
          biberonActif: this.state.biberonActif,
          rampeur: !this.state.marcheActif,
          biberonFrequence: 0,
          dateAcceptation: moment(this.state.dateAcceptation).format(
            "YYYY-MM-DD"
          ),
          dateNaissance: moment(this.state.dateNaissance).format("YYYY-MM-DD"),
          horairesDetails: { horaires: cleanHorraire },
          nom: nomprenomenfant[1],
          poid: this.state.poidsEnfant,
          prenom: nomprenomenfant[0],
          sexe: this.state.sexeEnfant,
          taille: this.state.tailleEnfant,
        };

        this.props.updateIdentiteSimpleInfoEnfant(
          localStorage.getItem("token"),
          this.props.kidItem.id,
          data
        );
        let formErrors = Object.assign({}, this.state.formErrors, {
          nomPrenom: "",
          sexeEnfant: "",
          poidsEnfant: "",
          tailleEnfant: "",
          dateNaissance: "",
          dateAcceptation: "",
          biberonActif: "",
          numJour: "",
        });
        this.setState({ formErrors: formErrors });
      }
    } else {
      let formErrors = Object.assign({}, this.state.formErrors, {
        nomPrenom: nomPrenom,
        sexeEnfant: validSexe,
        poidsEnfant: validPoids,
        tailleEnfant: validTaille,
        dateNaissance: validDateNaissance,
        dateAcceptation: validDateAccept,
        biberonActif: validBiberon,
        numJour: validNumJour,
      });
      this.setState({ formErrors: formErrors });
    }
  }
  handleSubmitInfoTierce(event) {
    event.preventDefault();
    let arrayValid = [];
    let newTierces = [];
    this.state.tierces.forEach((element, index) => {
      let name = "PrenomNomTierce" + index;
      let nameTel = "numeroTelT" + index;
      let validNom = element.nom ? "" : "sont obligatoires";
      let validPrenom = element.prenom ? "" : "sont obligatoires";
      let numeroTelValid = element.numeroTel.match(
        /^((\+)33|033|0)[1-9](\d{2}){4}$/g
      );
      let numeroTel =
        element.numeroTel && numeroTelValid
          ? ""
          : element.numeroTel && !numeroTelValid
            ? "Telephone est invalide"
            : "Ce champs est obligatoire";
      let formValid =
        _.isEmpty(validNom) && _.isEmpty(validPrenom) && _.isEmpty(numeroTel);
      let elementEmpty =
        _.isEmpty(element.nom) &&
        _.isEmpty(element.prenom) &&
        _.isEmpty(element.numeroTel);
      arrayValid.push(elementEmpty || formValid);
      let nomPrenom = validNom || validPrenom;
      if (formValid && !elementEmpty) {
        if (_.isEmpty(element.id)) {
          newTierces.push({
            lienDeParente: element.lienDeParente,
            nom: element.nom,
            numeroTel: element.numeroTel,
            prenom: element.prenom,
          });
        } else {
          newTierces.push({
            id: element.id,
            lienDeParente: element.lienDeParente,
            nom: element.nom,
            numeroTel: element.numeroTel,
            prenom: element.prenom,
          });
        }
      } else if (!elementEmpty && !formValid) {
        let formErrors = Object.assign({}, this.state.formErrors, {
          [name]: nomPrenom,
          [nameTel]: numeroTel,
        });
        this.setState({ formErrors: formErrors });
      } else {
        let formErrors = Object.assign({}, this.state.formErrors, {
          [name]: "",
          [nameTel]: "",
        });
        this.setState({ formErrors: formErrors });
      }
    });
    let data = {
      tiercesAutorises: newTierces,
    };
    if (arrayValid.every((element) => element) && !_.isEmpty(newTierces)) {
      this.props.updateIdentiteSimpleInfoTierce(
        localStorage.getItem("token"),
        this.props.kidItem.id,
        data
      );
      let formErrors = this.state.formErrors;
      newTierces.forEach((element, index) => {
        let name = "PrenomNomTierce" + index;
        let nameTel = "numeroTelT" + index;
        formErrors = Object.assign({}, formErrors, {
          [name]: "",
          [nameTel]: "",
        });
      });
      formErrors = Object.assign({}, formErrors, {
        PrenomNomTierceN: "",
        numeroTelN: "",
      });
      this.setState({ tierces: newTierces, formErrors: formErrors });
    } else if (_.isEmpty(newTierces)) {
      let formErrors = Object.assign({}, formErrors, {
        PrenomNomTierceN: "",
        numeroTelN: "",
      });
      let data = {
        tiercesAutorises: [],
      };
      this.props.updateIdentiteSimpleInfoTierce(
        localStorage.getItem("token"),
        this.props.kidItem.id,
        data
      );
      this.setState({ tierces: newTierces, formErrors: formErrors });
    }
  }
  showModalArchivage() {
    this.setState({ ModaleArchivage: true });
  }
  onSubmitArchive() {
    if (this.state.fromArchive) {
      this.props.recupererEnfant(
        localStorage.getItem("token"),
        this.props.kidItem.id
      );
      this.setState({ ModaleArchivage: false });
    } else {
      this.props.archiveEnfant(
        localStorage.getItem("token"),
        this.props.kidItem.id
      );
      this.setState({ ModaleArchivage: false });
    }
  }
  onCloseModaleArchive() {
    this.setState({ ModaleArchivage: false });
  }
  showModalSuppression() {
    this.setState({ ModaleSuppresion: true });
  }
  showModalSuppressionInfoParent(parent) {
    this.setState({ ModaleSuppresionInfoParent: true, selectedParentToDelete: parent });
  }
  onSubmitSuppression() {
    this.props.deleteEnfant(
      localStorage.getItem("token"),
      this.props.kidItem.id
    );
    this.setState({ ModaleSuppresion: false });
  }
  haveTwoParents() {
    var conteur = 0;
    this.state.parents.forEach((parent) => {
      if ( parent.id && !_.isEmpty(parent.id.toString())) {
        conteur ++;
      }
    });
    return conteur >= 2;
  }
  onSubmitSuppressionInfoParent() {
    var dataParents = [];
    if (this.haveTwoParents()) {
      dataParents = this.state.parents.filter((p) => p.id != this.state.selectedParentToDelete.id);
      dataParents =  dataParents.map((p) => {
        return {
          adresse: {
            codePostal: p.adresse.codePostal,
            pays: p.adresse.pays,
            rue: p.adresse.rue,
            ville: p.adresse.ville,
          },
          email: p.email,
          etatCompte: p.etatCompte,
          id: p.id,
          nom: p.nom,
          numeroTel: p.numeroTel,
          prenom: p.prenom,
          situation: p.situation,
        };
      })
      this.props.deleteIdentiteSimpleInfoParent(
        localStorage.getItem("token"),
        this.props.kidItem.id,
        { parents: dataParents }
      );
    }
    this.setState({ ModaleSuppresionInfoParent: false });
  }
  onCloseModaleSuppression() {
    this.setState({ ModaleSuppresion: false });
  }
  onCloseModaleSuppressionInfoParent() {
    this.setState({ ModaleSuppresionInfoParent: false });
  }
  showModalPhoto() {
    this.setState({ ModalePhoto: true });
  }
  onCloseModalePhoto() {
    this.setState({ ModalePhoto: false });
  }
  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      let sizeInMB = (e.target.files[0].size / (1024 * 1024)).toFixed(2);
      if (sizeInMB > 5) {
        let name = "";
        let message = "Impossible d'ajouter des photos supérieur à 5 méga";
        this.props.openSnackBar(name, message);
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () =>
          this.setState({
            file: reader.result,
            isUpload: true,
            modalUploadMobile: true,
          })
        );
        reader.readAsDataURL(e.target.files[0]);
      }
    }
  };
  onCloseUploadMobile() {
    this.setState({ modalUploadMobile: false, file: "" });
  }

  renderContent = () => {
    const classes = makeStyles((theme) => ({
      root: {
        "& > *": {
          margin: theme.spacing(1),
        },
      },
      input: {
        display: "none",
      },
    }));
    if (isMobile) {
      return (
        <div className={classes.root}>
          <input
            className={classes.input}
            id="contained-button-file"
            type="file"
            style={{ display: "none" }}
            onChange={this.onSelectFile}
            accept="image/png,image/bmp,image/jpeg"
          />

          {this.state.fromArchive ? (
            ""
          ) : (
            <div className="input-file-style mr-3">
              <label
                for="contained-button-file"
                className="btn-photo btn-gradient"
              >
                <img src={srcIconPhoto} className="img-fluid" alt="" />{" "}
              </label>
            </div>
          )}
        </div>
      );
    }
    return (
      <button
        disabled={this.state.fromArchive}
        type="bouton"
        className="btn-photo btn-gradient"
        data-toggle="modal"
        data-target="#modalPhoto"
        onClick={(e) => this.showModalPhoto(e)}
      >
        <img src={srcIconPhoto} className="img-fluid" alt="" />
      </button>
    );
  };

  render() {
    const { fromArchive } = this.state;
    var divStyle = (lienPhoto) => ({
      backgroundImage: "url(" + lienPhoto + ")",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    });

    return (
      <div
        className="tab-pane show active "
        id="identite-pane"
        role="tabpanel"
        aria-labelledby="identite-tab"
      >
        {this.props.loading ? (
          <div className="content p-0">
            <DotLoader
              size={100}
              color={"#ff7d26"}
              css={override}
              loading={this.props.loading}
            />
          </div>
        ) : (
          <div className="content p-0">
            <section className="content-section">
              <h2>{this.props.t('identite.child_info')}</h2>
              <div className="row">
                <div className="col-md-5">
                  <div
                    className={`form-group ${this.errorClass(
                      this.state.formErrors[`nomPrenom`]
                    )}`}
                  >
                    <input
                      disabled={fromArchive}
                      type="text"
                      className="form-control ipt-id-nom"
                      name="nomPrenom"
                      placeholder={this.props.t('fiche_enfant.prenom_nom')}
                      onChange={this.onChangeEnfant}
                      value={this.state.nomPrenom}
                    />
                    {(() => {
                      if (!_.isEmpty(this.state.formErrors["nomPrenom"])) {
                        return (
                          <p>
                            Nom et Prenom {this.state.formErrors["nomPrenom"]}
                          </p>
                        );
                      } else {
                        return "";
                      }
                    })()}
                  </div>
                  {/* Choix date NAISSANCE  */}
                  <div className="form-group">
                    <ThemeProvider theme={materialTheme}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePicker
                          autoOk
                          ampm={false}
                          value={this.state.dateNaissance}
                          onChange={this.handleChangeNaissance}
                          format={" DD MMM YYYY"}
                          TextFieldComponent={this.renderInput}
                          textLabel={this.props.t('identite.born_on')}
                          disabled={fromArchive}
                        />
                      </MuiPickersUtilsProvider>
                    </ThemeProvider>
                  </div>
                  <div
                    className={`form-group ${this.errorClass(
                      this.state.formErrors[`sexeEnfant`]
                    )}`}
                  >
                    <select
                      disabled={fromArchive}
                      onChange={this.handleChange}
                      value={this.state.sexeEnfant}
                      className="form-control ipt-id-heures"
                      name="sexeEnfant"
                    >
                      <option
                        value=""
                        disabled
                        hidden
                        className="form-control ipt-id-heures"
                      >
                        {this.props.t('identite.sex')}
                      </option>
                      <option defaultValue value="MALE">
                        {this.props.t('identite.boy')}
                      </option>
                      <option value="FEMELLE">{this.props.t('identite.girl')}</option>
                    </select>
                    {(() => {
                      if (!_.isEmpty(this.state.formErrors["sexeEnfant"])) {
                        return <p>{this.state.formErrors["sexeEnfant"]}</p>;
                      } else {
                        return "";
                      }
                    })()}
                  </div>
                  <div className="form-group">
                    <select
                      disabled={fromArchive}
                      onChange={(e) => {
                        const tok = localStorage.getItem("token");
                        const val = e.target.value;
                        this.setState({ selectedSectionId: val });
                        if (val === "") {
                          this.props.removeEnfantSection(tok, this.props.kidItem.id);
                        } else {
                          this.props.assignEnfantSection(tok, this.props.kidItem.id, parseInt(val));
                        }
                      }}
                      value={this.state.selectedSectionId !== undefined ? this.state.selectedSectionId : (this.props.kidItem.sectionId || "")}
                      className="form-control ipt-id-heures"
                      name="sectionEnfant"
                    >
                      <option value="">
                        {this.props.t('identite.section')}
                      </option>
                      {this.props.sections && this.props.sections.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.nom}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div
                    className={`form-group  ${this.errorClass(
                      this.state.formErrors[`poidsEnfant`]
                    )}`}
                  >
                    <div
                      className="kilo"
                      style={{ display: this.state.kilo ? "inline" : "none" }}
                    ></div>
                    <input
                      disabled={fromArchive}
                      type="number"
                      className="form-control ipt-id-heures poids"
                      name="poidsEnfant"
                      placeholder={this.props.t('fiche_enfant.poids')}
                      onChange={this.handleChangePoids}
                      value={this.state.poidsEnfant}
                    />

                    {(() => {
                      if (!_.isEmpty(this.state.formErrors["poidsEnfant"])) {
                        return <p>{this.state.formErrors["poidsEnfant"]}</p>;
                      } else {
                        return "";
                      }
                    })()}
                  </div>
                  <div
                    className={`form-group  ${this.errorClass(
                      this.state.formErrors[`tailleEnfant`]
                    )}`}
                    id="taille"
                  >
                    <div
                      className="taille"
                      style={{ display: this.state.taille ? "inline" : "none" }}
                    ></div>

                    <input
                      disabled={fromArchive}
                      type="number"
                      className="form-control ipt-id-heures "
                      name="tailleEnfant"
                      placeholder={this.props.t('fiche_enfant.taille')}
                      onChange={this.handleChange}
                      value={this.state.tailleEnfant}
                    />
                    {(() => {
                      if (!_.isEmpty(this.state.formErrors["tailleEnfant"])) {
                        return <p>{this.state.formErrors["tailleEnfant"]}</p>;
                      } else {
                        return "";
                      }
                    })()}
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="form-group">
                    <ThemeProvider theme={materialTheme}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePicker
                          disabled={fromArchive}
                          autoOk
                          ampm={false}
                          value={this.state.dateAcceptation}
                          onChange={this.handleChangeAdmission}
                          format={" DD MMM YYYY"}
                          TextFieldComponent={this.renderInput}
                          textLabel={this.props.t('identite.admitted_on')}
                        />
                      </MuiPickersUtilsProvider>
                    </ThemeProvider>
                  </div>
                  <div
                    className="row align-items-center row-horaires"
                    data-toggle="modal"
                    data-target="#modalHoraires"
                  >
                    <div className="col-md-6 pr-0">
                      <div
                        className={`form-group ${this.errorClass(
                          this.state.formErrors[`numJour`]
                        )}`}
                      >
                        <input
                          disabled={fromArchive}
                          type="text"
                          className="form-control ipt-id-jours"
                          name="numJour"
                          placeholder={this.props.t('fiche_enfant.frequency')}
                          onClick={this.showModalHoraires}
                          readOnly
                          value={this.state.numJour + " " + this.props.t('identite.days')}
                        />
                        {(() => {
                          if (!_.isEmpty(this.state.formErrors["numJour"])) {
                            return <p>{this.state.formErrors["numJour"]}</p>;
                          } else {
                            return "";
                          }
                        })()}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          disabled={fromArchive}
                          type="text"
                          className="form-control ipt-id-heures"
                          name="horaire"
                          placeholder={this.props.t('fiche_enfant.horaire')}
                          onClick={this.showModalHoraires}
                          readOnly
                          value={this.state.horaire}
                        />
                        {this.state.ModalHoraires ? (
                          <ModalHoraires
                            handleChangeTimeEnd={this.handleChangeTimeEnd}
                            handleChangeTimeStart={this.handleChangeTimeStart}
                            horaireDebut={this.state.horaireDebut}
                            horaireFin={this.state.horaireFin}
                            horaires={this.state.newHoraires}
                            handleChange={this.handleChangeHoraire}
                            onClose={this.onClose}
                            onSubmitModal={this.onSubmitModal}
                            title={this.props.t('creche.presence_schedule')}
                          />
                        ) : (
                          ""
                        )}
                        {(() => {
                          if (!_.isEmpty(this.state.formErrors["numJour"])) {
                            return (
                              <p
                                style={{
                                  marginTop: "45px",
                                }}
                              >
                                {" "}
                              </p>
                            );
                          } else {
                            return "";
                          }
                        })()}
                      </div>
                    </div>
                  </div>
                  <ul className="row list-enfants list-sans-avatar">
                    <li className="col-md-7">
                      <input
                        disabled={fromArchive}
                        type="checkbox"
                        id="marche"
                        value="marche"
                        onChange={this.handleChangeMarche}
                        checked={this.state.marcheActif}
                      />
                      <label
                        className="rounded15 box-shadow"
                        htmlFor="marche"
                        name="marcheActif"
                        checked={this.state.marcheActif}
                      >
                        <span className="avatar"></span>
                        <span className="name">{this.props.t('identite.walks')}</span>
                      </label>
                    </li>
                  </ul>
                  <ul className="row list-enfants list-sans-avatar">
                    <li className="col-md-7">
                      <input
                        disabled={fromArchive}
                        type="checkbox"
                        id="biberon"
                        value="biberon"
                        onChange={this.handleChangeBiberon}
                        checked={this.state.biberonActif}
                      />
                      <label
                        className="rounded15 box-shadow"
                        htmlFor="biberon"
                        name="biberonActif"
                        checked={this.state.biberonActif}
                      >
                        <span className="avatar"></span>
                        <span className="name">{this.props.t('identite.bottle_fed')}</span>
                      </label>
                    </li>
                  </ul>
                  {this.state.biberonActif ? (
                    <div
                      className={`form-group unit ${this.errorClass(
                        this.state.formErrors[`biberonActif`]
                      )}`}
                      id="frequence"
                    >
                      <div
                        className="frequence"
                        style={{
                          display: this.state.frequence
                            ? "inline-block"
                            : "none",
                        }}
                      ></div>

                      <input
                        disabled={fromArchive}
                        type="number"
                        className="form-control ipt-id-heures"
                        placeholder={this.props.t('fiche_enfant.biberon_hours')}
                        name="biberonFrequence"
                        value={this.state.biberonFrequence}
                        onChange={this.handleChange}
                      />
                      {(() => {
                        if (!_.isEmpty(this.state.formErrors["biberonActif"])) {
                          return <p>{this.state.formErrors["biberonActif"]}</p>;
                        } else {
                          return "";
                        }
                      })()}
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                <div className="col-md-2">
                  <div
                    className="photo-enfant"
                    style={
                      this.state.showPhoto == null
                        ? divStyle(this.state.lienPhoto)
                        : divStyle(
                          window.URL.createObjectURL(this.state.showPhoto)
                        )
                    }
                  >
                    {fromArchive ? "" : this.renderContent()}
                  </div>
                </div>
              </div>
              <p className="bottom-space"></p>
              {fromArchive ? (
                ""
              ) : (
                <div className="d-flex justify-content-center">
                  <button
                    disabled={fromArchive}
                    type="submit"
                    className="btn-gradient btn-valid"
                    onClick={(e) => this.handleSubmitInfoEnfant(e)}
                  >
                    <IconValider /> {this.props.t('common.validate')}
                  </button>
                </div>
              )}
            </section>

            {Array.from(this.state.parents, (parent, index) => (
              <section className="content-section" key={index}>
                <div className="delete-info-parent">
                {this.haveTwoParents() ? (
                        <button
                          type="submit"
                          className="delete-post  mb-4"
                          data-toggle="modal"
                          data-target="#modalDelete"
                          onClick={() => this.showModalSuppressionInfoParent(parent)}
                        >
                        </button>
                      ) : ""}
                <h2 className="title-parent">{this.props.t('identite.parent_info', { number: index + 1 })}</h2>
                </div>
                <div className="row align-items-stretch">
                  <div className="col-md-5">
                    <div
                      className={`form-group ${this.errorClass(
                        this.state.formErrors[`nomPrenom${index}`]
                      )}`}
                    >
                      <input
                        disabled={fromArchive}
                        type="text"
                        className="form-control ipt-id-nom"
                        name="nomPrenom"
                        onChange={(e) => this.onChangeNomParent(e, index)}
                        placeholder={this.props.t('fiche_enfant.prenom_nom')}
                        value={parent.PrenomNom}
                      />
                      {Object.keys(this.state.formErrors).map(
                        (fieldName, i) => {
                          if (
                            !_.isEmpty(this.state.formErrors[fieldName]) &&
                            `nomPrenom${index}` === fieldName
                          ) {
                            return (
                              <p key={i}>
                                Nom et Prenom {this.state.formErrors[fieldName]}
                              </p>
                            );
                          } else {
                            return "";
                          }
                        }
                      )}
                    </div>
                    <div
                      className={`form-group ${this.errorClass(
                        this.state.formErrors[`numeroTel${index}`]
                      )}`}
                    >
                      <input
                        disabled={fromArchive}
                        type="tel"
                        className="form-control ipt-id-tel"
                        name="numeroTel"
                        onChange={(e) =>
                          this.handleChangeMulitple(e, parent.id, index)
                        }
                        placeholder={this.props.t('fiche_enfant.telephone')}
                        value={parent.numeroTel}
                      />
                      {Object.keys(this.state.formErrors).map(
                        (fieldName, i) => {
                          if (
                            !_.isEmpty(this.state.formErrors[fieldName]) &&
                            `numeroTel${index}` === fieldName
                          ) {
                            return (
                              <p key={i}>
                                Téléphone {this.state.formErrors[fieldName]}
                              </p>
                            );
                          } else {
                            return "";
                          }
                        }
                      )}
                    </div>
                    <div
                      className={`form-group ${this.errorClass(
                        this.state.formErrors[`email${index}`]
                      )}`}
                    >
                      <input
                        disabled={fromArchive}
                        type="email"
                        key={index}
                        required
                        className="form-control ipt-id-email"
                        name="email"
                        onChange={(e) =>
                          this.handleChangeMulitple(e, parent.id, index)
                        }
                        placeholder={this.props.t('fiche_enfant.email')}
                        value={parent.email}
                      />
                      {Object.keys(this.state.formErrors).map(
                        (fieldName, i) => {
                          if (
                            !_.isEmpty(this.state.formErrors[fieldName]) &&
                            `email${index}` === fieldName
                          ) {
                            return (
                              <p key={i}>
                                Email {this.state.formErrors[fieldName]}
                              </p>
                            );
                          } else {
                            return "";
                          }
                        }
                      )}
                    </div>
                  </div>
                  <div className="col-md-5 ">
                    <div className="form-group">
                      <input
                        disabled={fromArchive}
                        onChange={(e) => this.onChangeAdresse(e, index)}
                        value={parent.adresse.rue}
                        name="rue"
                        type="text"
                        id={"adresse-etablissement" + index}
                        placeholder={this.props.t('fiche_enfant.address')}
                        className="form-control box-shadow custom-input ipt-id-adress2"
                      />
                    </div>
                    <div className="form-group">
                      <input
                        disabled={fromArchive}
                        onChange={(e) => this.onChangeAdresse(e, index)}
                        value={parent.adresse.codePostal}
                        name="codePostal"
                        type="number"
                        id={"cp-etablissement" + index}
                        placeholder={this.props.t('fiche_enfant.code_postal')}
                        className="form-control box-shadow custom-input ipt-id-adress2"
                      />
                    </div>
                    <div className="form-group">
                      <input
                        disabled={fromArchive}
                        onChange={(e) => this.onChangeAdresse(e, index)}
                        value={parent.adresse.ville}
                        name="ville"
                        type="text"
                        id={"ville-etablissement" + index}
                        placeholder={this.props.t('fiche_enfant.ville')}
                        className="form-control box-shadow custom-input ipt-id-adress2"
                      />
                    </div>
                    <div className="form-group">
                      <input
                        onChange={(e) => this.onChangeAdresse(e, index)}
                        name="pays"
                        type="text"
                        id={"ville-etablissement" + index}
                        placeholder={this.props.t('fiche_enfant.pays')}
                        className="form-control box-shadow custom-input ipt-id-adress2"
                        value={parent.adresse.pays}
                      />
                    </div>
                  </div>
                  <div className="col-md-2 d-flex felx-column align-items-center">
                    <div className=" mt-2 mb-auto">
                      <div className="couplage mt-4">
                        <div className="pt-4">
                          <p
                            style={{ display: "block" }}
                            className={Classnames(
                              { "couplage-inactif": !parent.couplageActif },
                              { "couplage-actif": parent.couplageActif }
                            )}
                          >
                            {parent.couplageActif === true
                              ? this.props.t('identite.coupling_active')
                              : this.props.t('identite.coupling_inactive')}
                          </p>
                          <label className="switch">
                            <input
                              type="checkbox"
                              onChange={(e) =>
                                this.handleChangeCouplage(
                                  e,
                                  parent.id,
                                  parent.couplageActif
                                )
                              }
                              name="couplageActif"
                              disabled={!parent.id || fromArchive}
                              checked={parent.couplageActif}
                            />
                            <span className="slider round"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="bottom-space"></p>
                {fromArchive ? (
                  ""
                ) : (
                  <div className="d-flex justify-content-center">
                    <button
                      disabled={fromArchive}
                      type="submit"
                      className="btn-gradient btn-valid"
                      onClick={(e) => this.handleSubmitInfoParent(e, index)}
                    >
                      <IconValider /> {this.props.t('common.validate')}
                    </button>
                    {this.state.ModaleSuppresionInfoParent ? (
                      <ModaleSuppressionInfoParent
                        onCloseModaleSuppressionInfoParent={
                          this.onCloseModaleSuppressionInfoParent
                        }
                        onSubmitSuppressionInfoParent={this.onSubmitSuppressionInfoParent}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </section>
             ))}

            <section className="content-section">
              <h2>{this.props.t('identite.authorized_tiers')}</h2>
              {Array.from(this.state.tierces, (tierce, index) => (
                <div key={index} className="row align-items-center mb-3">
                  <div className={fromArchive ? "col-md-6" : "col-md-5"}>
                    <div
                      className={`form-group ${this.errorClass(
                        this.state.formErrors[`PrenomNomTierce${index}`]
                      )}`}
                    >
                      <input
                        disabled={fromArchive}
                        type="text"
                        className="form-control ipt-id-nom"
                        name="PrenomNomTierce"
                        onChange={(e) => this.onChangeNomTierce(e, index)}
                        placeholder={this.props.t('identite.firstname_lastname')}
                        value={tierce.PrenomNomTierce}
                      />
                      {Object.keys(this.state.formErrors).map(
                        (fieldName, i) => {
                          if (
                            !_.isEmpty(this.state.formErrors[fieldName]) &&
                            `PrenomNomTierce${index}` === fieldName
                          ) {
                            return (
                              <p key={i}>
                                Nom et Prenom {this.state.formErrors[fieldName]}
                              </p>
                            );
                          } else if (
                            !_.isEmpty(this.state.formErrors[fieldName]) &&
                            `numeroTelT${index}` === fieldName
                          ) {
                            return (
                              <p
                                key={i}
                                style={{
                                  marginTop: "45px",
                                }}
                              ></p>
                            );
                          } else {
                            return "";
                          }
                        }
                      )}
                    </div>
                  </div>
                  <div className={fromArchive ? "col-md-6" : "col-md-5"}>
                    <div
                      className={`form-group ${this.errorClass(
                        this.state.formErrors[`numeroTelT${index}`]
                      )}`}
                    >
                      <input
                        disabled={fromArchive}
                        type="text"
                        className="form-control ipt-id-tel"
                        name="numeroTel"
                        onChange={(e) =>
                          this.handleChangeMulitpleTierces(e, index)
                        }
                        placeholder="xx xx xx xx xx"
                        value={tierce.numeroTel}
                      />
                      {Object.keys(this.state.formErrors).map(
                        (fieldName, i) => {
                          if (
                            !_.isEmpty(this.state.formErrors[fieldName]) &&
                            `numeroTelT${index}` === fieldName
                          ) {
                            return (
                              <p key={i}> {this.state.formErrors[fieldName]}</p>
                            );
                          } else if (
                            !_.isEmpty(this.state.formErrors[fieldName]) &&
                            `PrenomNomTierce${index}` === fieldName
                          ) {
                            return (
                              <p
                                key={i}
                                style={{
                                  marginTop: "45px",
                                }}
                              ></p>
                            );
                          } else {
                            return "";
                          }
                        }
                      )}
                    </div>
                  </div>
                  {fromArchive ? (
                    ""
                  ) : (
                    <div className="col-md-2 d-flex align-items-center">
                      <button
                        type="button"
                        disabled={fromArchive}
                        className="action-line delete"
                        onClick={(e) => this.deleteTierce(e, index)}
                      ></button>
                    </div>
                  )}
                </div>
              ))}
              {!_.isEmpty(this.props.account) &&
                this.props.account.compteType === "ADMIN_CRECHE" ? (
                <div className="row align-items-center mb-3">
                  <div className="col-md-5">
                    <div
                      className={`form-group ${this.errorClass(
                        this.state.formErrors[`PrenomNomTierceN`]
                      )}`}
                    >
                      <input
                        disabled={fromArchive}
                        type="text"
                        className="form-control ipt-id-nom"
                        name="PrenomNomTierce"
                        onChange={(e) => this.onChangeAddTierce(e)}
                        placeholder={this.props.t('identite.firstname_lastname')}
                        value={this.state.newTierce.PrenomNomTierce}
                      />
                      {Object.keys(this.state.formErrors).map(
                        (fieldName, i) => {
                          if (
                            !_.isEmpty(this.state.formErrors[fieldName]) &&
                            `PrenomNomTierceN` === fieldName
                          ) {
                            return (
                              <p key={i}>
                                Nom et Prenom {this.state.formErrors[fieldName]}
                              </p>
                            );
                          } else if (
                            !_.isEmpty(this.state.formErrors["numeroTelN"]) &&
                            _.isEmpty(this.state.formErrors["PrenomNomTierceN"])
                          ) {
                            return (
                              <p
                                key={i}
                                style={{
                                  marginTop: "45px",
                                }}
                              ></p>
                            );
                          } else {
                            return "";
                          }
                        }
                      )}
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div
                      className={`form-group ${this.errorClass(
                        this.state.formErrors[`numeroTelN`]
                      )}`}
                    >
                      <input
                        disabled={fromArchive}
                        type="text"
                        className="form-control ipt-id-tel"
                        name="numeroTel"
                        onChange={(e) => this.onChangeAddTierce(e)}
                        placeholder="xx xx xx xx xx"
                        value={this.state.newTierce.numeroTel}
                      />
                      {Object.keys(this.state.formErrors).map(
                        (fieldName, i) => {
                          if (
                            !_.isEmpty(this.state.formErrors[fieldName]) &&
                            `numeroTelN` === fieldName
                          ) {
                            return (
                              <p key={i}>{this.state.formErrors[fieldName]}</p>
                            );
                          } else if (
                            !_.isEmpty(
                              this.state.formErrors["PrenomNomTierceN"]
                            ) &&
                            _.isEmpty(this.state.formErrors["numeroTelN"])
                          ) {
                            return (
                              <p
                                key={i}
                                style={{
                                  marginTop: "45px",
                                }}
                              ></p>
                            );
                          } else {
                            return "";
                          }
                        }
                      )}
                    </div>
                  </div>
                  <div className="col-md-2 d-flex align-items-center">
                    <button
                      disabled={fromArchive}
                      style={
                        !_.isEmpty(this.state.formErrors["PrenomNomTierceN"]) ||
                          !_.isEmpty(this.state.formErrors["numeroTelN"])
                          ? { marginBottom: "45px" }
                          : {}
                      }
                      type="button"
                      className="action-line add"
                      onClick={this.showAddTierce}
                    ></button>
                  </div>
                </div>
              ) : (
                ""
              )}

              {this.state.showTierce ? (
                <div className="row align-items-center mb-3">
                  
                </div>
              ) : (
                ""
              )}
              <p className="bottom-space"></p>
              {fromArchive ? (
                ""
              ) : (
                <div className="d-flex justify-content-center">
                  <button
                    disabled={fromArchive}
                    type="button"
                    className="btn-gradient btn-valid"
                    onClick={(e) => this.handleSubmitInfoTierce(e)}
                  >
                    <IconValider /> {this.props.t('common.validate')}
                  </button>
                </div>
              )}
            </section>
            <section className="content-section">

              <h2>{this.props.t('identite.administration')}</h2>

              <div className="d-flex justify-content-center">
                <div
                  className="align-items-center md-5"
                  style={{
                    display: "flex",
                    flexWrap: " wrap",
                    marginRight: " -15px",
                    marginLeft: " -15px",
                  }}
                >
                  <div className="col-md-5">
                    <div className="form-group">
                      <button
                        type="submit"
                        className="btn-blue btn-valid"
                        data-toggle="modal"
                        data-target="#modalArchive"
                        onClick={(e) => this.showModalArchivage(e)}
                      >
                        {fromArchive ? this.props.t('common.reactivate') : this.props.t('common.archive')}
                      </button>
                      {this.state.ModaleArchivage ? (
                        <ModaleArchivage
                          onCloseModaleArchive={this.onCloseModaleArchive}
                          onSubmitArchive={this.onSubmitArchive}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {fromArchive ? (
                    ""
                  ) : (
                    <div className="col-md-5">
                      <div className="form-group">
                        <button
                          type="submit"
                          className="btn-delete btn-valid margin-left"
                          data-toggle="modal"
                          data-target="#modalDelete"
                          onClick={(e) => this.showModalSuppression(e)}
                        >
                          {this.props.t('common.delete')}
                        </button>
                        {this.state.ModaleSuppresion ? (
                          <ModaleSuppresion
                            onCloseModaleSuppression={
                              this.onCloseModaleSuppression
                            }
                            onSubmitSuppression={this.onSubmitSuppression}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <p className="bottom-space"></p>
            </section>
            {this.state.ModalePhoto ? (
              <ModalePhoto
                onCloseModalePhoto={this.onCloseModalePhoto}
                ModalePhoto={this.state.ModalePhoto}
                uploadPhoto={this.uploadPhoto}
                photo={this.state.lienPhoto}
              />
            ) : (
              ""
            )}
            {this.state.modalUploadMobile ? (
              <UploadMobile
                photo={this.state.file}
                onCloseUploadMobile={this.onCloseUploadMobile}
                getCroppedImage={this.getCroppedImage}
                uploadPhotoMobile={this.uploadPhotoMobile}
                styleFadeIn={this.state.styleFadeIn}
              />
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  account: state.auth.account,
  loading: state.auth.loading,
  sections: state.gestionCreche.sections.data,
});

export default connect(mapStateToProps, {
recupererEnfant,
  updateIdentiteSimpleInfoEnfant,
  updateIdentiteSimpleInfoParent,
  updateIdentiteSimpleInfoTierce,
  getAccount,
  archiveEnfant,
  deleteEnfant,
  deleteIdentiteSimpleInfoParent,
  updateCouplage,
  updatePhotoEnfant,
  openSnackBar,
  getSections,
  assignEnfantSection,
  removeEnfantSection,
})(withTranslation()(Identite));
